import React, { useEffect, useState } from 'react';
import "./order.css";
import api from '../../axiosInstance';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import {Dialog,DialogActions, DialogContent, DialogTitle, Button, TextField, Box,Gridv2,Typography, Modal} from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
// import { Button, TextField,  } from "@mui/material";
// import {  Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid2';
import TableHead from '@mui/material/TableHead';
import Swal from "sweetalert2";
import modalbg from "../../Assets/bg.jpg"
const theme = createTheme({
  typography: {
    fontFamily: "Calibri, sans-serif",
  },
});


function Order() {
  const { did, cid } = useParams(); // Extract ID from URL
  const [showForm, setShowForm] = useState(false);
  const [products, setProducts] = useState([]);  // Initialize as empty array
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [orderProducts, setOrderProducts] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [open, setOpen] = useState(false);
  //const [investmentModal, setInvestmentModal] = useState(false);
  const [investmentAmount, setInvestmentAmount] = useState("");

  // Open Investment Modal
  // const handleInvestmentOpen = () => {
  //   setInvestmentModal(true);
  // };

  // // Close Investment Modal
  // const handleInvestmentClose = () => {
  //   setInvestmentModal(false);
  // };

  // // Handle Submit Investment
  // const handleInvestmentSubmit = async () => {
  //   console.log("Investment Amount:", investmentAmount);
  //   setInvestmentModal(false);
  //    // Format the data as per the required structure
  //    const formattedData = {
  //     distributor_id: Number(cid)  // Replace with the actual distributor_id
     
  //   };
  //   console.log("Invest",formattedData)
  //   // Perform API call or state update if needed
  //   //https://distributorhub.zerobook.online/api/v1/distributorinvestment
  //   try {
  //     // Send the formatted data to the server using Axios
  //     const response = await api.get("distributorinvestment",formattedData);
  //     console.log("Data submitted successfully:", response);
  //     if (response.status == 200) {
  //       Swal.fire({
  //         title: "Success!",
  //         text: "Investment is added successfully!",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error submitting data:", error);
  //     Swal.fire({
  //       title: "Error!",
  //       text: "Failed to place order. Please try again.",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //   }
  // };

  console.log("CID", cid);
  const handleOpen = (orders) => {
    console.log("order id", orders)
    const selectedOrderProduct = orderProducts.filter((order) => order.id == orders)
    console.log("selectedOrderProduct", selectedOrderProduct[0].orders)
    setSelectedOrder(selectedOrderProduct[0].orders);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const ordercolumns = [
    { field: "order_id", headerName: "Order ID", flex: 1 },
    { field: "created_at", headerName: "Created At", flex: 2 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => {
        console.log("Cell Params:", params);
        return (
          <IconButton
            color="primary"
            onClick={() => handleOpen(params.row.id)}>
            <VisibilityIcon />
          </IconButton>
        );
      },
    },
  ];




  const fetchOrderProduct = async () => {
    try {
      //  cid = cid || did;
      console.log("didfdd", cid)

      const response = await api.get(`orderbydistributor/${cid}`)
      console.log("res", response)

      if (response?.data?.data?.length > 0) {
        console.log("fetchOrderProduct", response?.data?.data)
        setOrderProducts(response?.data?.data)

      }
      else {
        console.log("No orders found");

      }

    }
    catch (error) {
      console.log("error", error)
    }
  }



  const fetchProducts = async () => {

    try {
      const checkcompany = sessionStorage.getItem("providerId")
      let response
      if (checkcompany == 0) {
        response = await api.get("/products");
      }
      else {
        response = await api.get(`/getdistributorproduct?DIS=${did}`);

      }
      console.log("product list order", response?.data?.data)
      setProducts(
        response?.data?.data?.map(product => ({
          ...product,
          selling_price: "",
          qty: ""
        }))
      );
    }
    catch (error) {
      console.log("error", error)
    }

  }
  useEffect(() => {

    if (showForm) {
      fetchProducts()
    }
    else {
      fetchOrderProduct()

    }

  }, [showForm])

  console.log("product", products)

  const roworder = orderProducts?.map((order) => ({
    id: order.id,
    order_id: order.orderid,
    created_at: order.created_at,
    product_id: order.product_id,
    qty: order.qty,
    selling_price: order.selling_price,
    profit_amount: order.profit_amount,
    purchase_amount: order.purchase_amount,
    sale_amount: order.sale_amount,
  }))


  console.log("slected order", selectedOrder)


  const handleChange = (id, field, value) => {
    setProducts(prevProducts =>
      prevProducts.map(product =>
        product.id === id ? { ...product, [field]: value } : product
      )
    );
  };

  // const handleSelectionChange = (newSelection) => {
  //     console.log("newSelection",newSelection )
  //     setSelectedRows(newSelection.selectionModel); // Store selected row ids
  //   };

  const columns = [
    { field: "id", headerName: "ID", width: 100 },
    { field: "price", headerName: "Buying Price", width: 150 },
    { field: "name", headerName: "Name", width: 200 },
    {
      field: "selling_price",
      headerName: "Selling Price",
      width: 180,
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>

          <TextField
            value={params.row.selling_price}
            onChange={(e) =>
              handleChange(params.row.id, "selling_price", e.target.value)
            }
            type="number"
            variant="outlined"
            size="small"
            sx={{
              // "& .MuiInputBase-input": {
              //   fontSize: "12px", // Smaller font
              //   height: "55px", // Reduce height
              // },
              "& .MuiOutlinedInput-root": {
                height: "30px", // Overall height of TextField
                marginTop: "10px",
                width: "90%",
              },
              "@media (max-width: 600px)": {
                "& .MuiOutlinedInput-root": {
                  height: "30px", // Smaller height on small screens
                  width: "80%",
                },
              },
            }}
          />
        </Box>
      ),

    },
    {
      field: "qty",
      headerName: "Qty",
      width: 150,
      renderCell: (params) => (
        <TextField
          value={params.row.qty}
          onChange={(e) => handleChange(params.row.id, "qty", e.target.value)}
          type="number"
          variant="outlined"
          size="small"
          sx={{
            "& .MuiOutlinedInput-root": {
              height: "30px",
              marginTop: "10px",
              width: "80%",
            },
            "@media (max-width: 600px)": {
              "& .MuiOutlinedInput-root": {
                height: "30px", // Smaller height on small screens
                width: "80%",
              },
            },
          }}
        />
      ),
    },
  ];

  console.log("selectedProducts", rowSelectionModel);

  const handleSubmit = async () => {
    // Get selected products based on the selectionModel
    const selectedProducts = products.filter(product =>
      rowSelectionModel.includes(product.id)
    );

    console.log("myproduccts", selectedProducts)

    console.log("DISID", did, cid);
    // Format the data as per the required structure
    const formattedData = {
      distributor_id: Number(cid),  // Replace with the actual distributor_id
      product: selectedProducts.map(({ id, price, selling_price, qty }) => ({
        product_id: id,
        qty: Number(qty),
        buying_price: price,
        selling_price: Number(selling_price),
      }))
    };

    console.log("formattedData", formattedData)

    try {
      // Send the formatted data to the server using Axios
      const response = await api.post("distributorproduct", formattedData);
      console.log("Data submitted successfully:", response);
      if (response.status == 200) {
        Swal.fire({
          title: "Success!",
          text: "Order placed successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to place order. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };


  console.log("did", did)

  return (
    <div className='row' style={{ height: "100%" }}>
      <div className='col-sm-12 col-md-9'>
        <div style={{ height: "100%" }}>
          <div className=" d-flex flex-warp justify-content-between align-items-center p-2">
            <h3 className='distributerfont'>Order</h3>
            <div>
              <div className='d-flex align-items-center' >
                <TextField
                  id="standard-basic"
                  placeholder="Search"
                  variant="standard"
                  className='me-2'
                  sx={{
                    width: "8rem", // Set width
                    // "& input": {
                    //   fontSize: "14px", // Text inside the input field
                    // },
                    "& .MuiInputBase-input::placeholder": {
                      fontSize: "12px", // Reduce placeholder size

                    },
                  }}

                />
                <div className='search_icon'>
                  <SearchIcon fontSize='7px' />

                </div>
                <PersonIcon className='ms-2' />
                <div>

                </div>
              </div>
            </div>


          </div>
          <div className='d-flex justify-content-end'>
            {/* <button
              type="button"
              className="rounded submitbutton m-1"
              onClick={handleInvestmentOpen}
            >
              Add Investment
            </button> */}
            <button
              type="button"
              className="rounded submitbutton m-1 "
              onClick={() => {
                setShowForm(!showForm); // Toggle form visibility
              }}

            >
              {showForm ? "List Order" : "Create Order"}
            </button>
            {/* Investment Modal */}
            {/* <Dialog open={investmentModal} onClose={handleInvestmentClose} fullWidth maxWidth="sm">
              <DialogTitle>Enter Investment Amount</DialogTitle>
              <DialogContent>
                <TextField
                  label="Investment Amount"
                  type="number"
                  fullWidth
                  variant="outlined"
                  value={investmentAmount}
                  onChange={(e) => setInvestmentAmount(e.target.value)}
                  margin="normal"
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleInvestmentClose} color="secondary">
                  Cancel
                </Button>
                <Button onClick={handleInvestmentSubmit} color="primary" variant="contained">
                  Submit
                </Button>
              </DialogActions>
            </Dialog> */}
          </div>

          {
            showForm ? (
              <div>
                <ThemeProvider theme={theme}>
                  <div style={{ height: 400, width: "100%" }}>

                    <DataGrid
                      rowSpacingType='border'

                      rows={products}
                      columns={columns}
                      // rowsPerPageOptions={[5]}
                      checkboxSelection  // Enable checkbox selection
                      disableRowSelectionOnClick
                      onRowSelectionModelChange={(newRowSelectionModel) => {
                        setRowSelectionModel(newRowSelectionModel);
                      }}
                      rowSelectionModel={rowSelectionModel}
                      pagination={false}
                      hideFooter
                      sx={{
                        border: 'none', // Change outer border color
                        fontFamily: "Calibri, sans-serif",
                        "& .MuiCheckbox-root": {
                          padding: "4px",  // Reduce padding
                          transform: "scale(0.7)",  // Scale down checkbox size
                        },
                        "& .MuiDataGrid-row": {
                          border: "1px solid #dee2e6 !important",  // Remove row border
                          marginTop: "0.2rem",

                        },
                        "& .MuiDataGrid-cell": {
                          border: "none !important",  // Remove cell borders
                        },
                        "& .MuiDataGrid-columnHeaders": {
                          border: "none !important", // Remove header row bottom border

                        },
                        "& .MuiDataGrid-filler": {
                          rowBorderColor: "none"
                        },
                        "& .MuiDataGrid-root": {
                          border: "none !important", // Removes outer border
                        },

                      }}

                    />
                  </div>
                  <div className='d-flex justify-content-end'>
                    <button className='submitbutton mt-2' onClick={handleSubmit}>
                      Submit
                    </button>
                  </div>
                </ThemeProvider>
              </div>
            ) : (
              <div style={{ height: 400, overflow: "auto" }}>
                <ThemeProvider theme={theme}>
                  <DataGrid
                    rows={roworder}
                    columns={ordercolumns}
                    pageSize={5}
                    pagination={false}
                    hideFooter
                    //   onRowClick={(params) => setSelectedOrder(params.row)}
                    sx={{
                      border: "none",
                      "& .MuiDataGrid-root": {
                        border: "none !important", // Removes outer border
                      },
                      "& .MuiDataGrid-cell": {
                        border: "none !important",  // Remove cell borders
                      },
                      "& .MuiDataGrid-row": {
                        border: "1px solid #dee2e6 !important",  // Remove row border
                        marginTop: "0.2rem",

                      },

                      "& .MuiDataGrid-filler": {
                        rowBorderColor: "none"
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        border: "none", // Remove header row bottom border

                      },
                      "& .MuiDataGrid-filler": {
                        rowBorderColor: "none"
                      },

                    }}
                  />
                  {/* <Modal open={!!selectedOrder} onClose={() => setSelectedOrder(null)}> */}
                  <Modal open={open} onClose={handleClose}>
                    <Box
                      sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        // backgroundImage:"url('../')",
                        width: { xs: "95%", sm: "65%" }, // 90% width on mobile (xs) and 65% on small devices and up

                        bgcolor: "background.paper",
                        boxShadow: 24,
                        p: { xs: 0, md: 6 }, // No padding on mobile (xs), padding 6 on small screens and up

                        borderRadius: 2,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "auto",
                        backgroundImage: `url(${modalbg})`, // Set the background image
                        // backgroundSize: "cover", // Ensure the image covers the whole box
                        backgroundPosition: "center", // Center the background image
                        backgroundRepeat: "no-repeat", // Prevent image repetition
                      }}
                    >

                      <Box sx={{ width: "100%", boxShadow: 3, borderRadius: 2, bgcolor: "background.paper", padding: 2 }}>
                        <h5 style={{ textAlign: "left", color: "#6da5f0" }}>Order Details</h5>

                        {/* {selectedOrder && (
            <>
              <Typography variant="h6">Order Details</Typography>
              <Typography>ID: {selectedOrder.id}</Typography>
              <Typography>Product ID: {selectedOrder.product_id}</Typography>
              <Typography>Quantity: {selectedOrder.qty}</Typography>
              <Typography>Selling Price: {selectedOrder.selling_price}</Typography>
              <Typography>Profit Amount: {selectedOrder.profit_amount}</Typography>
              <Typography>Purchase Amount: {selectedOrder.purchase_amount}</Typography>
              <Typography>Sale Amount: {selectedOrder.sale_amount}</Typography>
              <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                onClick={() => setSelectedOrder(null)}
              >
                Close
              </Button>
            </>
          )} */}
                        {selectedOrder ? (
                          <>
                            <TableContainer >
                              <Table sx={{ border: "none" }}>
                                <TableHead>
                                  <TableRow sx={{ border: "none" }}>
                                    <TableCell sx={{ borderBottom: "none" }}><strong>ID</strong></TableCell>
                                    <TableCell sx={{ borderBottom: "none" }}><strong>Product ID</strong></TableCell>
                                    <TableCell sx={{ border: "none" }}><strong>Quantity</strong></TableCell>
                                    <TableCell sx={{ border: "none" }}><strong>Selling Price</strong></TableCell>
                                    <TableCell sx={{ border: "none" }}><strong>Profit Amount</strong></TableCell>
                                    <TableCell sx={{ border: "none" }}><strong>Purchase Amount</strong></TableCell>
                                    <TableCell sx={{ border: "none" }}><strong>Sale Amount</strong></TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {selectedOrder.map((order) => (
                                    <TableRow key={order.id}>
                                      <TableCell sx={{ border: "none" }}>{order.id}</TableCell>
                                      <TableCell sx={{ border: "none" }}>{order.product_id}</TableCell>
                                      <TableCell sx={{ border: "none" }}>{order.qty}</TableCell>
                                      <TableCell sx={{ border: "none" }}>{order.selling_price}</TableCell>
                                      <TableCell sx={{ border: "none" }}>{order.profit_amount}</TableCell>
                                      <TableCell sx={{ border: "none" }}>{order.purchase_amount}</TableCell>
                                      <TableCell sx={{ border: "none" }}>{order.sale_amount}</TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                            <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}>
                              <button
                                className='closebutton'
                                onClick={() => { setSelectedOrder(null); setOpen(false) }}
                              >
                                Close
                              </button>
                            </Box>

                          </>
                        ) : (
                          <Typography>No data found</Typography>
                        )}




                      </Box>
                    </Box>
                  </Modal>
                </ThemeProvider>
              </div>
            )
          }
        </div>
      </div>
      <div className='col-sm-12 col-md-3 distributerSideimage rounded-5 mt-md-0 mt-2 distributerfont'>
        <div className="bg-white my-4 mx-2 p-3 rounded-5">
          <h5>Details</h5>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam praesentium vel harum tempore eaque asperiores? Delectus voluptatum eligendi tempore fugit labore, officiis reiciendis, deserunt sunt cupiditate, minus sed omnis eveniet.
          </p>
        </div>

      </div>


    </div>
  )
}

export default Order